import { useSelector } from 'react-redux'
import { Field, useFormikContext } from 'formik'

import Select from 'components/Select'

import { getMerchants } from 'store/Merchants/selectors'

const Merchant = ({ title, id }) => {
  const { values, setFieldValue } = useFormikContext()
  const handleMerchantChange = (value) => {
    setFieldValue('merchantId', value)
  }

  const merchants = useSelector(getMerchants)

  return (
    <section>
      <h3 id={id} className="header-title">
        {title}
      </h3>
      <p className="modal-paragraph">
        A Merchant is required to accept payments in Mobile Ordering
        for this Revenue center
      </p>
      <div className="content-wrapper -flags-wrapper">
        <div className="select-box">
          <Field
            component={Select}
            handleChange={handleMerchantChange}
            label="Merchant"
            name="merchantId"
            options={merchants}
            defaultValue={values?.merchantId}
          />
        </div>
      </div>
    </section>
  )
}

export default Merchant
